import { render, staticRenderFns } from "./addPublic.vue?vue&type=template&id=7a6334b4&"
import script from "./addPublic.vue?vue&type=script&lang=js&"
export * from "./addPublic.vue?vue&type=script&lang=js&"
import style0 from "./addPublic.vue?vue&type=style&index=0&id=7a6334b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports